import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/product/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/product/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.product.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveProductAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_PRODUCT_ASYNC, vo });

            EditService.saveProduct(
                vo,
                response => {
                    dispatch(Actions.saveProductSuccess(response));
                },
                error => {
                    dispatch(Actions.saveProductFailure(error));
                }
            );
        };
    },

    saveProductSuccess: data => ({
        type: ActionTypes.SAVE_PRODUCT_SUCCESS,
        parentType: ActionTypes.SAVE_PRODUCT_ASYNC,
        data
    }),

    saveProductFailure: error => ({
        type: ActionTypes.SAVE_PRODUCT_FAILURE,
        parentType: ActionTypes.SAVE_PRODUCT_ASYNC,
        error
    }),

    createProduct: () => ({
        type: ActionTypes.CREATE_PRODUCT
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    product: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, product: data.product };
};

const createProductReducer = (state) => {
    return { ...state, product: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_PRODUCT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_PRODUCT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_PRODUCT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_PRODUCT]: createProductReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
